export class QuickSearchDrawers extends window.BAO.CustomElement() {
  constructor () {
    super()

    this._activeDrawerKey = ''
    this.dialogs = new Map()

    window.quickSearchDrawers = this
  }

  connectedCallback () {
    super.connectedCallback?.()

    // Cache all dialogs
    this.querySelectorAll('dialog[data-quick-search-drawer]').forEach((dialog) => {
      const key = dialog.getAttribute('data-quick-search-drawer')
      this.dialogs.set(key, dialog)
    })
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleClick.bind(this),
    )

    this.listeners.add(document.documentElement, 'keydown', (e) => {
      if (e.key === 'Escape') {
        this.close()
      }
    })

    // Listen for native dialog close events
    this.dialogs.forEach((dialog) => {
      this.listeners.add(dialog, 'close', () => {
        if (this._activeDrawerKey === dialog.getAttribute('data-quick-search-drawer')) {
          this._activeDrawerKey = ''
          this.updateBodyClasses()
        }
      })
    })
  }

  handleClick (e) {
    const trigger = e.target.closest('[data-quick-search-trigger]')
    const closeButton = e.target.closest('[data-quick-search-drawer-close]')
    const backdrop = e.target.closest('[data-quick-search-drawers-el="backdrop"]')

    // Check if click is on dialog backdrop (outside content)
    const dialog = e.target.closest('dialog[data-quick-search-drawer]')
    if (dialog && dialog.open && e.target === dialog) {
      const dialogDimensions = dialog.getBoundingClientRect()
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        e.preventDefault()
        this.close()
        return
      }
    }

    if (trigger) {
      e.preventDefault()
      const key = trigger.getAttribute('data-quick-search-trigger')
      if (key === this._activeDrawerKey) {
        this.close()
        this.updateTriggerText(trigger, false)
      } else {
        this.open(key)
        this.updateTriggerText(trigger, true)
      }
      return
    }

    if (closeButton || backdrop) {
      e.preventDefault()
      this.close()
    }
  }

  /**
   * @param {string} key
   */
  open (key) {
    // Close any open dialog first
    this.dialogs.forEach((dialog) => {
      if (dialog.open) {
        dialog.close()
      }
    })

    const dialog = this.dialogs.get(key)
    if (dialog) {
      this._activeDrawerKey = key
      if (key === 'desktop') {
        dialog.show()
      } else {
        dialog.showModal()
      }
      this.updateBodyClasses()

      // Focus input in the dialog
      const input = dialog.querySelector('[data-quick-search-el="input"]')
      if (input) {
        const focusInput = () => {
          input.focus()
        }

        if (key === 'desktop') {
          requestAnimationFrame(() => {
            setTimeout(focusInput, 300)
          })
        } else {
          requestAnimationFrame(focusInput)
        }
      }
    }
  }

  close () {
    const dialog = this.dialogs.get(this._activeDrawerKey)
    if (dialog?.open) {
      dialog.close()
    }

    // Reset trigger text
    const trigger = document.querySelector(`[data-quick-search-trigger="${this._activeDrawerKey}"]`)
    if (trigger) {
      this.updateTriggerText(trigger, false)
    }

    this._activeDrawerKey = ''
    this.updateBodyClasses()
  }

  /**
   * Update trigger button text based on open state
   * @param {HTMLElement} trigger
   * @param {boolean} isOpen
   */
  updateTriggerText (trigger, isOpen) {
    const openText = trigger.getAttribute('data-text-open')
    const closeText = trigger.getAttribute('data-text-close')

    if (openText && closeText) {
      trigger.textContent = isOpen ? closeText : openText
      trigger.setAttribute('aria-label', isOpen ? closeText : openText)
    }
  }

  updateBodyClasses () {
    const isOpen = this._activeDrawerKey !== ''

    this.classList.toggle('quick-search-Drawers-active', isOpen)

    // Mobile: overflow body
    if (this._activeDrawerKey === 'mobile') {
      document.body.classList.toggle('util-SiteOverflowed', isOpen)
    } else {
      document.body.classList.remove('util-SiteOverflowed')
    }

    // Remove all quick-search body classes
    document.body.classList.forEach((className) => {
      if (className.startsWith('quick-search-')) {
        document.body.classList.remove(className)
      }
    })

    if (isOpen) {
      document.body.classList.add(`quick-search-${this._activeDrawerKey}`)
    }

    document.dispatchEvent(new CustomEvent('quick-search-drawer-changed'))
  }

  get activeDrawerKey () {
    return this._activeDrawerKey
  }
}

customElements.define('quick-search-drawers', QuickSearchDrawers)
